import qs from 'qs';
import { network } from 'services/network';

export const renamePoapViewName = ({ viewId, newName }: QueryParams) => {
    const querystring = qs.stringify({ viewId, newName }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/renamePoapViewName${querystring}`;
    return network.post(url).then((response) => response.data);
};

export interface QueryParams {
    viewId: number;
    newName: string;
}
